import { ref } from 'vue';

// 创建事件总线
class EventBus {
  private events: Map<string, ((...args: any[]) => void)[]> = new Map();

  on(event: string, callback: (...args: any[]) => void) {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }
    this.events.get(event)!.push(callback);
  }

  emit(event: string, ...args: any[]) {
    if (this.events.has(event)) {
      this.events.get(event)!.forEach((callback) => callback(...args));
    }
  }

  off(event: string, callback: (...args: any[]) => void) {
    if (this.events.has(event)) {
      const callbacks = this.events.get(event)!;
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }
}

export const eventBus = new EventBus();

// 工具栏状态管理
export const toolbarState = {
  roadNetworkEditMode: ref(false),
  // 可以添加其他页面的状态
};
